import Resource, { ResourceApi } from '../../resource/Resource';
import { TERMS_OF_SERVICE, USER_RESOURCE } from '../resourceNames';
import {
  FETCH_LOGGED_IN_USER_DATA_SUCCESS,
  FETCH_LOGGED_IN_USER_TOS_ACCEPTANCE_DATES_SUCCESS,
} from './actions';

export function retrieveLoggedInUserData({ userId }) {
  return (dispatch) => {
    Resource.read(USER_RESOURCE, userId, 'getLoggedInUserData').then(
      (userData) => {
        dispatch({
          type: FETCH_LOGGED_IN_USER_DATA_SUCCESS,
          userId,
          userData,
        });
      }
    );
  };
}

export const retrieveLoggedInUserTosAcceptanceDates = ({ userId }) => {
  return (dispatch) => {
    ResourceApi.lookup(
      TERMS_OF_SERVICE,
      'get_all_latest_terms_of_service_acceptance_date_for_user',
      { user_id: userId }
    ).then((dates) => {
      dispatch({
        type: FETCH_LOGGED_IN_USER_TOS_ACCEPTANCE_DATES_SUCCESS,
        userId,
        dates,
      });
    });
  };
};
